import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinus, faPlus } from "@fortawesome/free-solid-svg-icons";
import classNames from "classnames";

import "../../styles/faqs.css";

export const FAQComponent = () => {

    const [opened, setOpened] = useState();

    const openUnit = (id) => {
        opened === id ? setOpened() : setOpened(id);
    }

    return (
        <div className="faq-container">
            <div className="faq-unit" onClick={() => openUnit(1)}>
                <div className="faq-top">
                    <button className={classNames("disp-button",{"rot-button": opened === 1})}>
                        <FontAwesomeIcon
                            icon={opened === 1 ? faMinus : faPlus}
                        />
                    </button>
                    <div className="faq-question">WHAT ARE THE DELIVERY TIMES?</div>
                </div>

                <div className={classNames("faq-answer", { 'open': opened === 1 })}>
                    Our delivery times are within 3 hours for Douala, and 24 hours for other cities.
                </div>
            </div>
            <div className="faq-unit" onClick={() => openUnit(2)}>
                <div className="faq-top">
                    <button className={classNames("disp-button",{"rot-button": opened === 2})}>
                        <FontAwesomeIcon
                            icon={opened === 2 ? faMinus : faPlus}
                        />
                    </button>
                    <div className="faq-question">HOW IS PAYMENT DONE?</div>
                </div>
                <div className={classNames("faq-answer", { 'open': opened === 2 })}>
                    <p>You can pay the delivery agent in cash or by MTN momo or Orange money upon receipt of your order</p>
                    <ul>
                        <li>Please ensure you have the exact amount of payment</li>
                        <li>We only accept payment in FCFA</li>
                    </ul>
                </div>
            </div>
            <div className="faq-unit" onClick={() => openUnit(3)}>
                <div className="faq-top">
                    <button className={classNames("disp-button",{"rot-button": opened === 3})}>
                        <FontAwesomeIcon
                            icon={opened === 3 ? faMinus : faPlus}
                        />
                    </button>
                    <div className="faq-question">WHERE ARE WE LOCATED?</div>
                </div>
                <div className={classNames("faq-answer", { 'open': opened === 3 })}>
                    We are located at <strong>Carrefour Ancient Pharmacie, BONADIBONG, DOUALA</strong>
                </div>
            </div>
            <div className="faq-unit" onClick={() => openUnit(4)}>
                <div className="faq-top">
                    <button className={classNames("disp-button",{"rot-button": opened === 4})}>
                        <FontAwesomeIcon
                            icon={opened === 4 ? faMinus : faPlus}
                        />
                    </button>
                    <div className="faq-question">WHAT IS THE QUALITY OF ITEMS SOLD?</div>
                </div>
                <div className={classNames("faq-answer", { 'open': opened === 4 })}>
                    We sell both new and used items, all of which have passed rigourous quality checks. Our products are 100% authentic.
                </div>
            </div>
        </div>
    )
}